module.exports = __webpack_public_path__ + "img/Flag_of_Slovakia.e9a55d79.svg";